import { isNotEmpty } from '@qsxy/element-plus-react';
import { IMenu } from '@/typings';
import settings from './settings';
import menus from './menus';

export const routers: IMenu[] = [...menus, ...settings];

export function addRoute(menu: IMenu[], result: IMenu[]) {
	menu.forEach(item => {
		const { url, children = [], ...other } = item;
		if (children.length > 0) {
			addRoute(children, result);
		}
		if (isNotEmpty(url)) {
			result.push({
				url,
				...other,
			});
		}
	});
	return result;
}

export const routeConfig = addRoute(routers, []);
export const authRouteConfig = addRoute(settings, []);
